import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PassInterceptionStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PassIntercepted &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const startFragment = play.getPreceedingFragment(fragment, [
            FootballState.Pass,
            FootballState.FieldGoalFakePass,
            FootballState.PatPass
        ]);

        const returned_yards =
            (fragment.returnedAt - fragment.interceptedAt) *
            -1 *
            gameContext.getFieldDirectionMultiplier();

        const stats = [];
        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: startFragment.passedBy.teamId,
                playerId: startFragment.passedBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: startFragment.id,
                category: FootballStatsCategory.PASS,
                values: {
                    interceptions: 1
                }
            },
            stats
        );

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: fragment.interceptedBy.teamId,
                playerId: fragment.interceptedBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: fragment.id,
                category: FootballStatsCategory.INTERCEPTION,
                values: {
                    completed: 1
                }
            },
            stats
        );

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: fragment.returnedBy.teamId,
                playerId: fragment.returnedBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: fragment.id,
                category: FootballStatsCategory.INTERCEPTION_RETURN,
                values: {
                    completed: 1,
                    yards: returned_yards
                }
            },
            stats
        );

        return stats;
    }
}
